export function listNewsIndex_filedMirgrants(node) {
  // 列数  字段迁移
  if (node.data.attribute.listitem_value) {
    node.data.attribute.listV2_value = node.data.attribute.listitem_value
  }

  // 列间距  字段迁移
  if (node.data.design.listitem_colPadding) {
    node.data.design.listV2_gapValue = node.data.design.listitem_colPadding
  }
  if (node.data.design.listitem_colPaddingUnit) {
    node.data.design.listV2_gapUnit = node.data.design.listitem_colPaddingUnit
  }

  // 行间距  字段迁移
  if (node.data.design.listitem_rowMargin) {
    node.data.design.listV2_rowGap = node.data.design.listitem_rowMargin
  }
  if (node.data.design.listitem_rowMarginUnit) {
    node.data.design.listV2_rowGapUnit = node.data.design.listitem_rowMarginUnit
  }


  return node
}
